import React from "react"
import { SanityNextImg } from "../../../cms/components"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"
import DesktopOnly from "../../../root/punks/mui/visibility/DesktopOnly"
import MobileOnly from "../../../root/punks/mui/visibility/MobileOnly"
import { paperBackground } from "../../../themes/variables"
import Dot from "../../atoms/Dot"
import { CustomCol, CustomRow } from "../../spacings"
import { TimelineItem } from "./types"

interface Props {
  even: boolean
  item: TimelineItem
}

const colStyles = {
  paddingLeft: "15%",
  paddingRight: "15%",
}

const TimelineBlockItem = ({ even, item }: Props) => {
  return (
    <CustomRow alignItems="center" reverse={!even} className="relative">
      <CustomCol xs={12} sm={6} className="py-8">
        <div style={colStyles}>
          <TwRichTextField
            className="mb-1"
            variant="h5"
            weight="normal"
            value={item.caption}
          />
          <TwRichTextField variant="h5" value={item.title} weight="bold" />
          <TwRichTextField variant="body1" value={item.body} className="mt-6" />
        </div>
      </CustomCol>
      <CustomCol xs={12} sm={6} className="py-8">
        <div style={colStyles}>
          <SanityNextImg blurUp asset={item.image} />
        </div>
      </CustomCol>
      <DesktopOnly className="absolute top-0 h-full" style={{ right: "50%" }}>
        <div
          className="relative h-full"
          style={{ borderRight: `1px solid ${paperBackground}` }}
        >
          <Dot
            color="disabled"
            className="absolute"
            style={{ top: "50%", right: -8 }}
            size="15px"
          />
        </div>
      </DesktopOnly>
      <MobileOnly className="absolute top-0 h-full left-2">
        <div
          className="relative h-full"
          style={{ borderRight: `1px solid ${paperBackground}` }}
        >
          <Dot
            color="disabled"
            className="absolute"
            style={{ top: 50, right: -8 }}
            size="15px"
          />
        </div>
      </MobileOnly>
    </CustomRow>
  )
}

export default TimelineBlockItem
